import { Controller } from "@hotwired/stimulus"

// Live feedback on the rooms step (Altima specs, step 4). Mirrors Realty#retained_rooms and the
// rooms validations: the server stays the real gate, this only shows the messages and disables Suivant.
export default class extends Controller {
  static targets = ["rooms", "over40", "over80", "total", "verandaAnswer", "veranda", "dependencyAnswer", "dependency", "error"]
  static values = { maxRooms: Number }

  connect() {
    this.update()
  }

  update() {
    // Three separate counts: 9 to 40 m² (1 room each), 40 to 80 m² (2 rooms each), 80 m² or more (3 rooms each).
    const small = this.number(this.roomsTarget)
    const over40 = this.number(this.over40Target)
    const over80 = this.number(this.over80Target)
    // A surface only counts once "Oui" is answered (Realty clears it on "Non").
    const veranda = this.checked(this.verandaAnswerTargets) === "true" ? this.checked(this.verandaTargets) : null
    const dependency = this.checked(this.dependencyAnswerTargets) === "true" ? this.checked(this.dependencyTargets) : null
    const retained = small + 2 * over40 + 3 * over80 + (veranda === "9-40" ? 1 : 0)
    this.totalTarget.textContent = retained

    const failing = {
      too_many_retained_rooms: this.hasMaxRoomsValue && retained > this.maxRoomsValue,
      no_rooms: small + over40 + over80 === 0,
      too_many_over_40: over40 + over80 > 2,
      too_many_over_80: over80 > 1,
      veranda_too_large: veranda === "40+",
      dependency_too_large: dependency === "100+"
    }

    // No room yet on arrival: Suivant stays disabled, the message only shows once a count went back to 0.
    const shown = (rule) => failing[rule] && (rule !== "no_rooms" || this.counted)
    this.errorTargets.forEach((error) => error.classList.toggle("d-none", !shown(error.dataset.rule)))
    const submit = this.element.closest("form")?.querySelector(".submit-step")
    if (submit) submit.disabled = Object.values(failing).some(Boolean)
  }

  increment(event) {
    this.step(event, 1)
  }

  decrement(event) {
    this.step(event, -1)
  }

  // Each count is a hidden field shown as text between the − and + buttons, from 0 to 9.
  step(event, delta) {
    const group = event.currentTarget.parentElement
    const input = group.querySelector("input")
    input.value = Math.min(Math.max(this.number(input) + delta, 0), 9)
    group.querySelector("span").textContent = input.value
    this.counted = true
    this.update()
  }

  checked(radios) {
    return radios.find((radio) => radio.checked)?.value
  }

  number(input) {
    return parseInt(input.value, 10) || 0
  }
}
